import React, { Component, Fragment } from "react";
import {
  Card,
  CardBody,
  Button,
  Table,
} from "reactstrap";

import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';

import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'
import * as orderActions from './actions'
import * as common from '../../lib/common'
import ButtonExt from "../controls/ButtonExt"
import { BtnPermissions } from '../../lib/BtnPermissions'
import printJS from 'print-js';
var dbContext;
class ProcessOrderDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      donXuatId: '',
      orderInfor: {},
      orderItems: []
    }
  }

  // in đơn hàng
  printClick = (orderInfor) => {
    this.props.loadOrderExport({ donXuatId: orderInfor.Id }, (data) => {
      console.log("data", data)
      let dataPrint = data;
      var pdfFile = new Blob([dataPrint], {
        type: "application/pdf;charset=UTF-8"
      });
      var pdfUrl = URL.createObjectURL(pdfFile);
      printJS(pdfUrl);
    });
  }
  // xoá đơn hàng với những đơn chưa tiếp nhận xử lý
  deleteClick = (item) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>THÔNG BÁO?</h1>
            <p>Bạn có muốn xoá đơn xuất kho <b className="text-danger">{item.MaXuatKho}</b> không?<br />
              Việc này đồng nghĩa đơn hàng sẽ cập nhật về trạng thái chưa tạo phiếu xuất.
            </p>
            <button className="text-danger" onClick={() => {
              this.props.processOrderDeleteOrder({ xuatKhoId: item.Id }, (data) => {
                this.return2List()
              })
              onClose()
            }}>Đồng ý</button>
            <button onClick={onClose}>Hủy bỏ</button>
          </div>
        )
      }
    });
  }
  processOrderClick = (orderInfor) => {
    this.props.history.push(`/process-order-checkqr/${orderInfor.Id}`);
  }
  return2List = () => {
    this.props.history.push(`/process-order-checked`);
  }
  getOrderDetail = () => {
    const params = this.props.match ? this.props.match.params : {};
    if (params) {
      const { id } = params;
      this.setState({ donXuatId: id }, () => {
        this.fetchData(id)
      })
    }
  }
  fetchData = (orderId) => {
    const payload = {
      xuatKhoId: orderId || this.props.orderId
    }
    this.props.getOrderDetails(payload, (data) => {
      this.setState({ orderInfor: data.xuatKho || {}, orderItems: data.items })
    })
  }

  componentDidMount() {
    this.getOrderDetail();
  }

  componentWillUnmount() {
    // reset callback func
    this.props.setCallbackFunc(() => { })
  }
  render() {
    const sumQuantity = () => {
      const items = this.state.orderItems || [];
      return common.sum(items, "SoLuong").toLocaleString()
    }

    const getItems = e => {
      const items = this.state.orderItems || [];
      return items.map((item, idx) => {
        return (
          <tr key={idx}>
            <td scope="col" className="text-center">
              {idx + 1}
            </td>
            <td scope="col" className="text-justify">
              {`${item.Sku}/ ${item.TenHang}`}
            </td>
            <td scope="col" className="text-left">
              {item.BarCode}
            </td>
            <td scope="col" className="text-justify">
              {item.Dvt}
            </td>
            <td scope="col" className="text-right">
              {item.SoLuong.toLocaleString()}
            </td>
          </tr>
        )
      });
    }
    const {
      processOrderDetail: {
        requesting,
        errors,
        messages,
      }
    } = this.props
    const { orderInfor } = this.state
    return (
      <div className="animated fadeIn order">
        <BlockUi tag="div" blocking={requesting}>
          <div className="col-sm-12 pull-left order-view">
            <Card>
              <CardBody className="p-1">
                <div className="col-sm-12">
                  <div className="col-sm-6 mb-2 pull-left view-row">
                    <span>Mã xuất kho: <b>{orderInfor.MaXuatKho || ''}</b></span>
                  </div>
                  <div className="col-sm-6 mb-2 pull-left view-row">
                    <span>Trạng thái: {orderInfor.TrangThai == 2 ? <span className="text-success font-weight-bold">Đã xác nhận</span> : <span className="text-danger font-weight-bold">Chưa xác nhận</span>}</span>
                  </div>
                  <div className="col-sm-6 mb-2 pull-left view-row">
                    <span>Nhân viên: <b>{orderInfor.TenNhanVien || ''}</b></span>
                  </div>
                  <div className="col-sm-6 mb-2 pull-left view-row">
                    <span>Ngày lập: <b>{orderInfor.NgayTao != '' ? orderInfor.TenNguoiTao + " - " + common.formatDateTime(orderInfor.NgayTao, "HH:mm DD/MM/YYYY") : ''}</b></span>
                  </div>
                  <div className="col-sm-12 mb-2 pull-left view-row">
                    <span>Ghi chú: <b>{orderInfor.GhiChuXuatThieu || ''}</b></span>
                  </div>
                </div>
                <div className="clearfix"></div>
                {!requesting && (
                  <div className="col-sm-12">
                    {!!errors.length && (
                      <Errors message="Failure to signup due to:" errors={errors} />
                    )}
                    {!!messages.length && (
                      <Messages messages={messages} />
                    )}
                  </div>
                )}
                {!requesting && (
                  <div className="col-sm-12">
                    <div role="group">
                      <Button className="btn btn-secondary mr-1 mb-1" onClick={() => this.return2List()}>
                        <i className="fa fa-list"></i> Danh sách
                      </Button>
                      <ButtonExt size="md" btnClass="btn btn-info mr-1" btnClick={() => this.processOrderClick(orderInfor)}
                        iconClass="fa-check" displayText="Xuất kho"
                        permission={BtnPermissions.DonHang.PROCESS_EXPORT_ORDER} />
                      {
                        orderInfor.TrangThai != 2 ?
                          <ButtonExt size="md" btnClass="btn btn-danger mr-1" btnClick={() => this.deleteClick(orderInfor)}
                            iconClass="fa-remove" displayText={"Xoá đơn"}
                            permission={BtnPermissions.DonXuatKho.DELETE_ORDER} />
                          : ''
                      }
                      <ButtonExt size="md" btnClass="btn btn-success mr-1" btnClick={() => this.printClick(orderInfor)}
                        iconClass="fa-print" displayText="In đơn"
                        permission={""} />
                    </div>
                  </div>
                )}
                <div className="col-sm-12 mb-2">
                  <Table hover responsive className="table-outline table-sm mb-0">
                    <thead className="thead-default">
                      <tr className="hide-in-mobile">
                        <th scope="col" width="50" className="text-center table-border-right">#</th>
                        <th scope="col" className="text-justify">
                          Tên thuốc
                        </th>
                        <th scope="col" width="120" className="text-left">
                          Mã vạch
                        </th>
                        <th scope="col" className="text-justify">
                          ĐVT
                        </th>
                        <th scope="col" className="text-right">
                          Số lượng
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {getItems()}
                    </tbody>
                    <tfoot className="thead-default">
                      <tr>
                        <td colSpan="2" scope="col" className="text-left">
                          <span className="text-primary font-weight-bold">Tổng cộng: </span>
                        </td>
                        <td colSpan="3" scope="col" className="text-right font-weight-bold">
                          {sumQuantity()}
                        </td>
                      </tr>
                    </tfoot>
                  </Table>
                </div>
              </CardBody>
            </Card>
          </div>
          <div className="clearfix"></div>
        </BlockUi>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  processOrderDetail: state.processOrderDetail
})

const connected = connect(mapStateToProps,
  {
    setIsLoading: orderActions.setIsLoading,
    getOrderDetails: orderActions.getOrderDetails,
    processOrderDeleteOrder: orderActions.processOrderDeleteOrder,
    setCallbackFunc: orderActions.setCallbackFunc,
    loadOrderExport: orderActions.loadOrderExport
  })(ProcessOrderDetail)

const formed = reduxForm({
  form: 'processOrderDetail',
})(connected)

export default formed;



// WEBPACK FOOTER //
// ./src/views/ProcessOrders/ProcessOrderDetails.js